/* global CountUp */
/**
 * File blockwheels-countup.js.
 * Gets the countup running in viewport.
 */
( function() {
	'use strict';
	window.BlockwheelsBlocksCounter = {
		cache: {},
		countUpItems: {},
		listenerCache: {},
		isInViewport: function(el) {
			const rect = el.getBoundingClientRect();
			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		
			);
		},
		initScrollSpy: function() {
			window.BlockwheelsBlocksCounter.countUpItems = document.querySelectorAll( '.blockwheels-counter' );
			if ( ! window.BlockwheelsBlocksCounter.countUpItems.length ) {
				return;
			}
			for ( let n = 0; n < window.BlockwheelsBlocksCounter.countUpItems.length; n++ ) {
				let self = window.BlockwheelsBlocksCounter.countUpItems[n],
					start     = self.dataset.start,
					end       = self.dataset.end,
					prefix     = self.dataset.prefix,
					suffix    = self.dataset.suffix,
					duration  = self.dataset.duration,
					separator = self.dataset.separator,
					decimal   = ( self.dataset.decimal ? self.dataset.decimal : false ),
					decimalSpaces   = ( self.dataset.decimalSpaces ? self.dataset.decimalSpaces : false ),
					el = self.querySelector('.blockwheels-counter-process');
				let theSeparator = ( separator === 'true' ? ',' : separator );
				theSeparator = ( theSeparator === 'false' ? '' : theSeparator );
				let KbCounterOptions = {
					startVal: start ? start : 0,
					duration: duration ? duration : 2,
					prefix: prefix ? prefix : '',
					suffix: suffix ? suffix : '',
					separator: theSeparator,
					decimal: decimal,
					decimalPlaces: decimalSpaces,
				};
				window.BlockwheelsBlocksCounter.cache[n] = new countUp.CountUp( el, end, KbCounterOptions);
				window.BlockwheelsBlocksCounter.accessabilityModifications( el, end );
				// Initialize listener
				window.BlockwheelsBlocksCounter.listenerCache[n] = window.BlockwheelsBlocksCounter.listener( n );
				document.addEventListener( 'scroll', window.BlockwheelsBlocksCounter.listenerCache[n], { passive: true } );
				window.BlockwheelsBlocksCounter.startCountUp( n );
			}
		},
		accessabilityModifications( el, end ) {
			var div = document.createElement("div");
			div.classList.add('screen-reader-text');
			div.innerHTML = end;
			el.before(div);
			el.setAttribute("aria-hidden", "true");
		},
		/**
		 * Start Listener.
		 */
		listener: function( index ) {
			return function curried_func( e ) {
				window.BlockwheelsBlocksCounter.startCountUp( index );
			}
		},
		/**
		 * Start function.
		 */
		startCountUp: function( index ) {
			if ( window.BlockwheelsBlocksCounter.isInViewport( window.BlockwheelsBlocksCounter.countUpItems[index] ) ) {
				if ( ! window.BlockwheelsBlocksCounter.cache[index].error ) {
					window.BlockwheelsBlocksCounter.cache[index].start();
				}
				document.removeEventListener( 'scroll', window.BlockwheelsBlocksCounter.listenerCache[index], false );
			}
		},
		// Initiate sticky when the DOM loads.
		init: function() {
			window.BlockwheelsBlocksCounter.initScrollSpy();
		}
	}
	if ( 'loading' === document.readyState ) {
		// The DOM has not yet been loaded.
		document.addEventListener( 'DOMContentLoaded', window.BlockwheelsBlocksCounter.init );
	} else {
		// The DOM has already been loaded.
		window.BlockwheelsBlocksCounter.init();
	}
}() );
